<template>
    <div>
        <!-- loading spinner -->
        <div v-if="!deviceDataLoaded" id="live-data-loading" style="text-align: center;">
            <div class="lds-facebook">
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div>Connecting to live data feed...</div>
        </div>

        <div v-else-if="deviceDataLoaded" style="padding-top: 100px; text-align: center; min-width: 1000px; max-width: 1000px;">
            <div class="image-container" style="min-width: 1000px; max-width: 1000px;">
                <img style="width: 1000px;" src="../../assets/images/refrigeration-image-placeholder.png">
                <div class="motors_lc_pump_speedpv">{{motors_lc_pump_speedpv}}</div>
                <div class="pids_lc_flow_anlg_scaled">{{pids_lc_flow_anlg_scaled}}</div>
                <div class="analogs_lc_lst_scaled">{{analogs_lc_lst_scaled}}</div>
                <div class="analogs_lc_lrt_scaled">{{analogs_lc_lrt_scaled}}</div>
                <div class="motors_lc_pump_freqpv">{{motors_lc_pump_freqpv}}</div>
                <div class="analogs_ht_sct_scaled">{{analogs_ht_sct_scaled}}</div>
                <div class="motors_lc_pump_powerpv">{{(motors_lc_pump_powerpv - 3)}}</div>
                <div class="motors_lc_pump_currentpv">{{(12 )}}</div>
                <div class="analogs_lt_dst_scaled">{{analogs_lt_dst_scaled}}</div>
                <div class="analogs_lt_sct_scaled">{{analogs_lt_sct_scaled}}</div>
                <div class="analogs_lt_scp_scaled">{{analogs_lt_scp_scaled}}</div>
            </div>
        </div>
    </div>
</template>

<script>
/* Static data for virtual device */
import staticVirtualDeviceData from './Trends/virtual_device_full_trends.json';

function modifyDatePart(timestamp) {
    // Create a new Date object from the timestamp
    const date = new Date(timestamp);

    // Get the current date without time
    const today = new Date();
    today.setHours(date.getHours())
    today.setMinutes(date.getMinutes());
    today.setSeconds(date.getSeconds());

    // Return the modified timestamp
    return today;
}
for (let i = 0; i < staticVirtualDeviceData.length; i++) {
    let element = staticVirtualDeviceData[i]
    element.t_stamp = modifyDatePart(element.t_stamp);
}

export default {
    name: 'DeviceImageData_Virtual',
    components: {
    },
    data: function () {
        return {
            deviceDataLoaded: false,
            refrigDataIntervalID: null,

            motors_lc_pump_speedpv: null,
            pids_lc_flow_anlg_scaled: null,
            analogs_lc_lst_scaled: null,
            analogs_lc_lrt_scaled: null,
            motors_lc_pump_freqpv: null,
            analogs_ht_sct_scaled: null,
            motors_lc_pump_powerpv: null,
            motors_lc_pump_currentpv: null,
            analogs_lt_dst_scaled: null,
            analogs_lt_sct_scaled: null,
            analogs_lt_scp_scaled: null,
        };
    },
    props: ['item'],
    mounted() {
        this.getDeviceImageData();            
    },
    beforeDestroy () {
        clearInterval(this.refrigDataIntervalID)
    },      
    methods: {
        async getDeviceImageData() {
            // Get the static data for the virtual device
            
            let pids_lc_flow_pid_pv = staticVirtualDeviceData.filter(temp => temp.Tag == "pids_lc_flow_pid_pv" && new Date(temp.t_stamp).toUTCString() <= new Date().toUTCString())
            this.pids_lc_flow_anlg_scaled = (pids_lc_flow_pid_pv[pids_lc_flow_pid_pv.length - 1].TagValue - 3).toFixed(1);
            
            let analogs_lc_lst_scaled = staticVirtualDeviceData.filter(temp => temp.Tag == "analogs_lc_lrt_scaled" && new Date(temp.t_stamp).toUTCString() <= new Date().toUTCString())
            this.analogs_lc_lst_scaled = analogs_lc_lst_scaled[analogs_lc_lst_scaled.length - 1].TagValue.toFixed(1);
            
            let analogs_lc_lrt_scaled = staticVirtualDeviceData.filter(temp => temp.Tag == "analogs_lc_lrt_scaled" && new Date(temp.t_stamp).toUTCString() <= new Date().toUTCString())
            this.analogs_lc_lrt_scaled = analogs_lc_lrt_scaled[analogs_lc_lrt_scaled.length - 1].TagValue.toFixed(1);
            
            let motors_lc_pump_freqpv = staticVirtualDeviceData.filter(temp => temp.Tag == "pids_lc_flow_pid_out" && new Date(temp.t_stamp).toUTCString() <= new Date().toUTCString())
            this.motors_lc_pump_freqpv = motors_lc_pump_freqpv[motors_lc_pump_freqpv.length - 1].TagValue.toFixed(1);

            let analogs_ht_sct_scaled = staticVirtualDeviceData.filter(temp => temp.Tag == "analogs_ht_sct_scaled" && new Date(temp.t_stamp).toUTCString() <= new Date().toUTCString())
            this.analogs_ht_sct_scaled = analogs_ht_sct_scaled[analogs_ht_sct_scaled.length - 1].TagValue.toFixed(1);
            
            let motors_lc_pump_powerpv = staticVirtualDeviceData.filter(temp => temp.Tag == "pids_lc_flow_pid_out" && new Date(temp.t_stamp).toUTCString() <= new Date().toUTCString())
            this.motors_lc_pump_powerpv = motors_lc_pump_powerpv[motors_lc_pump_powerpv.length - 1].TagValue.toFixed(1);
            
            let motors_lc_pump_currentpv = staticVirtualDeviceData.filter(temp => temp.Tag == "pids_lc_flow_pid_out" && new Date(temp.t_stamp).toUTCString() <= new Date().toUTCString())
            this.motors_lc_pump_currentpv = motors_lc_pump_currentpv[motors_lc_pump_currentpv.length - 1].TagValue.toFixed(1);
            
            let analogs_lt_dst_scaled = staticVirtualDeviceData.filter(temp => temp.Tag == "analogs_lt_dst_scaled" && new Date(temp.t_stamp).toUTCString() <= new Date().toUTCString())
            this.analogs_lt_dst_scaled = analogs_lt_dst_scaled[analogs_lt_dst_scaled.length - 1].TagValue.toFixed(1);
            
            let analogs_lt_sct_scaled = staticVirtualDeviceData.filter(temp => temp.Tag == "analogs_lt_sct_scaled" && new Date(temp.t_stamp).toUTCString() <= new Date().toUTCString())
            this.analogs_lt_sct_scaled = analogs_lt_sct_scaled[analogs_lt_sct_scaled.length - 1].TagValue.toFixed(1);
            
            let analogs_lt_scp_scaled = staticVirtualDeviceData.filter(temp => temp.Tag == "analogs_lt_scp_scaled" && new Date(temp.t_stamp).toUTCString() <= new Date().toUTCString())
            this.analogs_lt_scp_scaled = analogs_lt_scp_scaled[analogs_lt_scp_scaled.length - 1].TagValue.toFixed(1);

            this.deviceDataLoaded = true;
        },
    }
}
</script>

<style>
/* Container holding the image and the text */
.image-container {
  position: relative;
  text-align: center;
  font-size: large;
  font-weight: bold;
  /*color: white;*/
}


.pids_lc_flow_anlg_scaled
{
    position: absolute;
    top: 9%;
    left: 82%;
}

.analogs_lc_lst_scaled
{
    position: absolute;
    top: 9%;
    left: 68%;
}

.analogs_lc_lrt_scaled 
{
    position: absolute;
    top: 39%;
    left: 75%;
}

.analogs_ht_sct_scaled
{
    position: absolute;
    top: 62%;
    left: 24%;   
}

.motors_lc_pump_freqpv
{
    position: absolute;
    top: 56.5%;
    left: 75%;
}

.motors_lc_pump_powerpv
{
    position: absolute;
    top: 63.5%;
    left: 75%;
}

.motors_lc_pump_currentpv
{
    position: absolute;
    top: 71%;
    left: 75%;
}

.analogs_lt_dst_scaled
{
    position: absolute;
    top: 62%;
    left: 42.5%;
}

.analogs_lt_sct_scaled
{
    position: absolute;
    top: 62%;
    left: 54%;
}

.analogs_lt_scp_scaled
{
    position: absolute;
    top: 74%;
    left: 541px;
}
</style>